/* eslint-disable react/no-multi-comp */

import React from 'react'
import { FormattedMessage } from 'react-intl'

const emptyPlaceholder = '--'

export const OPEN_BATTLE_LIST_BUTTON_CAPTION = (
    <FormattedMessage
        id='clan_panel.unit_create_button_caption'
        defaultMessage='Сражения кланов'
    />
)

export const JOURNAL_TITLE = (
    <FormattedMessage
        id='clan_panel.item.journal_title'
        defaultMessage='Журнал'
    />
)

export const JOURNAL_DETAILS = (count) => (
    <FormattedMessage
        id='clan_panel.item.journal_details'
        defaultMessage='{count} событий сегодня'
        values={{ count }}
    />
)

export const JOURNAL_TOOLTIP = (
    <FormattedMessage
        id='clan_panel.item.journal_tooltip'
        defaultMessage='Нажмите, чтобы просмотреть прошедшие события в Укрепрайоне.'
    />
)

export const JOURNAL_TOOLTIP_ID = 'clan_panel_journal_tooltip'

export const CLAN_MANAGEMENT_TITLE = (
    <FormattedMessage
        id='clan_panel.item.clan_management.title'
        defaultMessage='Личный состав'
    />
)

export const CLAN_MANAGEMENT_TOOLTIP_FOOTER = (
    <FormattedMessage
        id='clan_panel.item.clan_management.tooltip.footer'
        defaultMessage='Нажмите, чтобы перейти к списку игроков клана.'
    />
)

export const CLAN_MANAGEMENT_TOOLTIP_ID = 'clan_panel_management_tooltip'

export const MEMBERS_ONLINE = (membersOnline, membersTotal) => (
    <FormattedMessage
        id='clan_panel.item.clan_management.members'
        defaultMessage='В сети: {membersOnline}/{membersTotal}'
        values={{
            membersOnline: membersOnline || emptyPlaceholder,
            membersTotal: membersTotal || emptyPlaceholder,
        }}
    />
)

export const MEMBERS_ONLINE_TOOLTIP = (membersOnline, membersTotal) => (
    <FormattedMessage
        id='clan_panel.item.clan_management.tooltip.members'
        defaultMessage='Игроков клана в сети: {membersOnline} из {membersTotal}'
        values={{
            membersOnline: membersOnline || emptyPlaceholder,
            membersTotal: membersTotal || emptyPlaceholder,
        }}
    />
)

export const CHALLENGES_TITLE = (
    <FormattedMessage
        id='clan_panel.challenges_title'
        defaultMessage='Военные игры'
    />
)

export const CHALLENGES_OFF = (
    <FormattedMessage
        id='clan_panel.challenges_off'
        defaultMessage='Отключены'
    />
)

export const CHALLENGES_TIMER = (timer) => (
    <FormattedMessage
        id='clan_panel.challenges_timer_left'
        defaultMessage='Осталось {timer}'
        values={{ timer }}
    />
)

export const CHALLENGES_TOOLTIP_OFF = (
    <FormattedMessage
        id='clan_panel.challenges_tooltip.off'
        defaultMessage='Военные игры отключены'
    />
)

export const CHALLENGES_TOOLTIP_FOOTER = (
    <FormattedMessage
        id='clan_panel.challenges_tooltip.footer'
        defaultMessage='Нажмите, чтобы перейти к военным играм.'
    />
)

export const CHALLENGES_TOOLTIP_NEXT_CUSTOM_DATE = (dateTime) => (
    <FormattedMessage
        id='clan_panel.challenges_tooltip.next_custom'
        defaultMessage='Следующие Военные игры начнутся {date} в {time}'
        values={{
            date: dateTime.format('D MMMM'),
            time: dateTime.format('LT'),
        }}
    />
)

export const CHALLENGES_TOOLTIP_NEXT_TODAY = (dateTime) => (
    <FormattedMessage
        id='clan_panel.challenges_tooltip.next_today'
        defaultMessage='Следующие Военные игры начнутся сегодня в {time}'
        values={{
            time: dateTime.format('LT'),
        }}
    />
)

export const CHALLENGES_TOOLTIP_NEXT_TOMORROW = (dateTime) => (
    <FormattedMessage
        id='clan_panel.challenges_tooltip.next_tomorrow'
        defaultMessage='Следующие Военные игры начнутся завтра в {time}'
        values={{
            time: dateTime.format('LT'),
        }}
    />
)

export const CHALLENGES_TOOLTIP_ENDS = (timer) => (
    <FormattedMessage
        id='clan_panel.challenges_tooltip.ends'
        defaultMessage='До завершения текущих Военных игр осталось {timer}'
        values={{ timer }}
    />
)

export const CHALLENGES_TOOLTIP_NEXT_STAGE_CUSTOM_DATE = (dateTime) => (
    <FormattedMessage
        id='clan_panel.challenges_tooltip.next_stage_custom'
        defaultMessage='Следующий этап Военных игр начнётся {date} в {time}'
        values={{
            date: dateTime.format('D MMMM'),
            time: dateTime.format('LT'),
        }}
    />
)

export const CHALLENGES_TOOLTIP_NEXT_STAGE_TODAY = (dateTime) => (
    <FormattedMessage
        id='clan_panel.challenges_tooltip.next_stage_today'
        defaultMessage='Следующий этап Военных игр начнётся сегодня в {time}'
        values={{
            time: dateTime.format('LT'),
        }}
    />
)

export const CHALLENGES_TOOLTIP_NEXT_STAGE_TOMORROW = (dateTime) => (
    <FormattedMessage
        id='clan_panel.challenges_tooltip.next_stage_tomorrow'
        defaultMessage='Следующий этап Военных игр начнётся завтра в {time}'
        values={{
            time: dateTime.format('LT'),
        }}
    />
)

export const CHALLENGES_TOOLTIP_STAGE_ENDS = (timer) => (
    <FormattedMessage
        id='clan_panel.challenges_tooltip.stage_ends'
        defaultMessage='До завершения текущего этапа Военных игр осталось {timer}'
        values={{ timer }}
    />
)

export const CHALLENGES_TOOLTIP_ID = 'clan_panel_challenges_tooltip'

export const OPEN_BATTLE_LIST_BUTTON_TOOLTIP_ID = 'clan_panel_create_unit_button_tooltip'

export const OPEN_BATTLE_LIST_BUTTON_TOOLTIP_MESSAGE = (
    <FormattedMessage
        id='clan_panel.item.open_battle_list_button_tooltip'
        defaultMessage='Нажмите, чтобы перейти к подбору отряда.'
    />
)

export const OPEN_BATTLE_LIST_BUTTON_TOOLTIP_UNITS_AVAILABLE = (count) => (
    <FormattedMessage
        id='clan_panel.item.open_battle_list_button_tooltip_units_available'
        defaultMessage='Отряды, созданные вашим кланом: {count}'
        values={{ count }}
    />
)

export const INDUSTRIAL_RESOURCE_BUYIN_BUTTON = (
    <FormattedMessage
        id='clan_panel.item.industrial_resource_buyin_button'
        defaultMessage='Купить промресурс'
    />
)



// WEBPACK FOOTER //
// ./containers/ClanPanel/constants.jsx